/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import { FormGroup, FormControl, Button, Label, Modal } from 'react-bootstrap'
import { useForm, Controller, SubmitHandler } from 'react-hook-form'
import ReactSelect, { Option } from 'react-select'

import LiveLoading from 'live/components/ui/Loading'
import authorization from 'live/services/authorization'
import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { IAlarmsAsset } from 'plugin-codaf-risk-ext-bowtie/BowtieAlarms/BowtieAlarms'
import { BowtieAlarmsRouteContext } from 'plugin-codaf-risk-ext-bowtie/BowtieAlarms/BowtieAlarmsWrapper'
import { NewGroupSubscriptions } from 'plugin-codaf-risk-ext-bowtie/BowtieAlarms/components/NewGroupScreen/components/NewGroupSubscriptions/NewGroupSubscriptions'
import { AbsoluteLoadingContainer } from 'plugin-codaf-risk-ext-bowtie/BowtieAlarms/styles'
import { EditorTopBar, NoUserModal } from 'plugin-codaf-risk-ext-bowtie/generic'
import { listBowties } from 'plugin-codaf-risk-ext-bowtie/services'
import { createAlarmGroup, getAlarmGroup, updateAlarmGroup } from 'plugin-codaf-risk-ext-bowtie/services/alarms'
import { listUser, LiveUser } from 'plugin-codaf-risk-ext-bowtie/services/users'
import { IBowtie } from 'plugin-codaf-risk-ext-bowtie/types'
import { IAlarmBowtie, IAlarmGroup } from 'plugin-codaf-risk-ext-bowtie/types/alarms'

import { FormContainer, NewGroupScreenContainer } from './styles'

interface IFormData {
    groupName: string
    groupDescription: string
}

const formDefault: IFormData = {
    groupName: '',
    groupDescription: undefined
}
interface IProps {
    setAlarmGroupToDelete: (k: number) => void
    setInLoading: (k: boolean) => void
    alarmGroupToDelete: number
    setAlarmGroupNameToDelete: (k: string) => void
    alarmGroupNameToDelete: string
}

export const NewGroupScreen: React.FC<IProps> = ({
    setAlarmGroupNameToDelete,
    setAlarmGroupToDelete,
    setInLoading
}) => {
    const [alarmGroup, setAlarmGroup] = useState<IAlarmGroup>()
    const [users, setUsers] = useState<Map<string, LiveUser>>(new Map())
    const [loading, setLoading] = useState(true)
    const [showingModal, setShowingModal] = useState(false)
    const [assetsList, setAssetsList] = useState<IAlarmsAsset[]>([])
    const [previousAlarmBowties, setPreviousAlarmBowties] = useState<IAlarmBowtie[]>()

    const [selectedBowtie, setSelectedBowtie] = useState<Map<number, Map<number, number[]>>>(
        new Map(assetsList.map(asset => [asset.id, new Map(asset.operations.map(operation => [operation.id, []]))]))
    )

    const { params, setParams } = useContext(BowtieAlarmsRouteContext)
    const { handleSubmit, control, setValue } = useForm<IFormData>({
        mode: 'all',
        defaultValues: formDefault
    })

    const transformFEBowtieFromAPI = (bowties: IBowtie[]): IAlarmsAsset[] => {
        const assets: IAlarmsAsset[] = []

        for (const bowtie of bowties) {
            let assetIndex = assets.findIndex(ast => ast.id === bowtie.asset.id)

            if (assetIndex === -1) {
                assets.push({ ...bowtie.asset, operations: [] })
                assetIndex = assets.length - 1
            }

            let operationIndex = assets[assetIndex].operations.findIndex(
                op => op.id === bowtie.topEvent.hazard.operation.id
            )

            if (operationIndex === -1) {
                assets[assetIndex].operations.push({ ...bowtie.topEvent.hazard.operation, bowties: [] })
                operationIndex = assets[assetIndex].operations.length - 1
            }

            assets[assetIndex].operations[operationIndex].bowties.push(bowtie)
        }

        for (const [idx, asset] of assets.entries()) {
            if (asset.operations.length < 1 || !asset.operations.every(op => op.bowties?.length)) {
                delete assets[idx]
            }
        }

        assets.sort((a, b) => a.name.localeCompare(b.name))

        return assets
    }

    async function getAllBowties(): Promise<void> {
        try {
            setInLoading(true)
            const { data: bowtieList } = await listBowties()

            setAssetsList(transformFEBowtieFromAPI(bowtieList))
        } catch (err) {
            globalNotification.error(err.message ?? i18n('An error occurred on list bowties.'))
        } finally {
            setInLoading(false)
        }
    }
    const transformAlarmBowties = (selectedBowtie: Map<number, Map<number, number[]>>) => {
        const bowtieIds: number[] = []
        Array.from(selectedBowtie).map(resource =>
            Array.from(resource[1]).map(operation => operation[1].map(bowtieId => bowtieIds.push(bowtieId)))
        )
        const bowtieTransformedIds: IAlarmBowtie[] = []
        bowtieIds.map(bowtieId => bowtieTransformedIds.push({ bowtieId: bowtieId }))
        setAlarmGroup({ ...alarmGroup, alarmBowties: bowtieTransformedIds })
    }

    const handleVerifyUser: SubmitHandler<IFormData> = async data => {
        if (alarmGroup.alarmUsers.length === 0) {
            setShowingModal(true)
        } else {
            handleSave(data)
        }
    }

    const handleSave: SubmitHandler<IFormData> = async data => {
        if (data.groupName.length <= 0) {
            globalNotification.error(i18n('Please, input a name for alarm group.'))
        } else {
            if (data.groupDescription == undefined || !data.groupDescription.length > 0) {
                globalNotification.error(i18n('Please, input a description for alarm group.'))
            } else {
                if (params.id) {
                    await updateAlarmGroup({
                        groupName: data.groupName,
                        groupDescription: data.groupDescription,
                        alarmBowties: alarmGroup.alarmBowties,
                        alarmUsers: alarmGroup.alarmUsers,
                        liveGroupAuthor: authorization.user.username,
                        id: alarmGroup.id
                    })

                    setParams({ type: 'list' })
                    globalNotification.success(i18n('The alarms group was updated successfully.'))
                }
                if (params.new) {
                    await createAlarmGroup({
                        groupName: data.groupName,
                        groupDescription: data.groupDescription,
                        alarmBowties: alarmGroup.alarmBowties,
                        alarmUsers: alarmGroup.alarmUsers,
                        liveGroupAuthor: authorization.user.username
                    })
                    setParams({ type: 'list' })
                    globalNotification.success(i18n('The alarms group was created successfully.'))
                }
            }
        }
    }

    useEffect(() => {
        getAllBowties()
    }, [])

    useEffect(() => {
        const handleGetData = async (): Promise<void> => {
            try {
                setLoading(true)

                if (params.id) {
                    const localAlarmGroup = await getAlarmGroup(params.id)
                    setAlarmGroup(localAlarmGroup)
                    setPreviousAlarmBowties(localAlarmGroup.alarmBowties)
                    setSelectedBowtie(
                        new Map(
                            assetsList.map(asset => [
                                asset.id,
                                new Map(
                                    asset.operations.map(operation => [
                                        operation.id,
                                        operation.bowties
                                            .map(bowtie => {
                                                if (
                                                    localAlarmGroup.alarmBowties.find(ab => ab.bowtieId === bowtie.id)
                                                ) {
                                                    return bowtie.id
                                                }
                                            })
                                            .filter(e => e)
                                    ])
                                )
                            ])
                        )
                    )
                    setValue('groupName', localAlarmGroup.groupName)
                    setValue('groupDescription', localAlarmGroup.groupDescription)
                } else {
                    setAlarmGroup({ groupName: ``, alarmUsers: [], groupDescription: `` } as IAlarmGroup)
                }

                setUsers(new Map((await listUser()).map(user => [user.username, user])))
            } catch (error) {
                globalNotification.error(error.message ?? i18n('An error occurred on fetching alarm group.'))
            } finally {
                setLoading(false)
            }
        }

        handleGetData()
    }, [assetsList])

    useEffect(() => {
        transformAlarmBowties(selectedBowtie)
    }, [selectedBowtie])

    if (loading) {
        return (
            <AbsoluteLoadingContainer>
                <h3>{i18n('Loading')}</h3>
                <div>
                    <LiveLoading size="lg" show />
                </div>
            </AbsoluteLoadingContainer>
        )
    }

    return (
        <>
            <NewGroupScreenContainer>
                <EditorTopBar
                    title={[
                        { text: i18n('Alarms Configurations'), maxWidth: '' },
                        { text: alarmGroup === undefined ? i18n('New Group') : i18n('Group Edition'), maxWidth: '' }
                    ]}
                    handleGoBack={() => setParams({ type: 'list' })}
                    disabled={false}
                    hideSaveButton={true}
                >
                    <div
                        className="delete-alarm-group"
                        onClick={() => {
                            if (alarmGroup !== undefined) {
                                setAlarmGroupToDelete(alarmGroup.id)
                                setAlarmGroupNameToDelete(alarmGroup.groupName)
                            }
                        }}
                    >
                        <span>{i18n('DeleteAlarm')}</span>
                        <i className={`far fa-trash-alt ${alarmGroup === undefined ? 'disabled' : ''} ingroup`} />
                    </div>
                </EditorTopBar>
                <div className="new-group-body">
                    <FormContainer>
                        <FormGroup className="body-form-group">
                            <div className="form-text-inputs">
                                <div className="label-input-bundle">
                                    <Controller
                                        name="groupName"
                                        control={control}
                                        render={({ field }) => (
                                            <>
                                                <Label>{i18n('4Group')}</Label>
                                                <FormControl
                                                    type="text"
                                                    onChange={field.onChange}
                                                    value={field.value}
                                                    maxLength={50}
                                                    id="alarmgroup-name-edition"
                                                />
                                            </>
                                        )}
                                    />
                                </div>
                                <div className="label-input-bundle">
                                    <Controller
                                        name="groupDescription"
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field }) => (
                                            <>
                                                <Label>{i18n('Description')}</Label>
                                                <FormControl
                                                    type="text"
                                                    componentClass="textarea"
                                                    onChange={field.onChange}
                                                    value={field.value}
                                                    maxLength={255}
                                                    id="alarmgroup-description-edition"
                                                />
                                            </>
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="form-select">
                                <div className="label-input-bundle">
                                    <Label>{i18n('Users')}</Label>
                                    <ReactSelect
                                        placeholder={`${i18n('Select')}...`}
                                        options={Array.from(users.values())
                                            .map(user => ({ ...user, label: user.name, value: user.id }))
                                            // ?.map((user: Option<string>) => ({ label: user.name, value: user.username }))
                                            .filter(option =>
                                                (alarmGroup?.alarmUsers ?? []).every(user => user.id !== option.id)
                                            )}
                                        onChange={(e: Option<string>) => {
                                            setAlarmGroup(o => ({
                                                ...o,
                                                alarmUsers: [
                                                    ...(o?.alarmUsers ?? []),
                                                    { liveUserName: e.username, email: e.email, id: e.id }
                                                ]
                                            }))
                                        }}
                                        id="alarmgroup-user-edition"
                                    />
                                </div>
                                <div className="list-user">
                                    {alarmGroup?.alarmUsers?.map(user => {
                                        return (
                                            <label className="name-user" key={user.liveUserName}>
                                                {users.get(user.liveUserName)?.name ?? i18n(`Unknown`)}
                                                <i
                                                    className="fas fa-times-circle"
                                                    onClick={() => {
                                                        const newAlarmUsers = alarmGroup.alarmUsers.filter(
                                                            option => option.liveUserName !== user.liveUserName
                                                        )
                                                        setAlarmGroup({ ...alarmGroup, alarmUsers: newAlarmUsers })
                                                    }}
                                                ></i>
                                            </label>
                                        )
                                    })}
                                </div>
                            </div>
                        </FormGroup>

                        <NewGroupSubscriptions
                            assets={assetsList}
                            setSelectedBowties={setSelectedBowtie}
                            selectedBowties={selectedBowtie}
                            setAlarmGroup={setAlarmGroup}
                            alarmGroup={alarmGroup}
                        />
                        <div className="new-group-save">
                            <Button
                                className="no-outline-button"
                                bsStyle="primary"
                                onClick={handleSubmit(handleVerifyUser)}
                                id="alarmGroup-list-button-alarmGroup"
                                style={{ marginRight: 12 }}
                                disabled={!alarmGroup?.alarmBowties?.length > 0 || !alarmGroup?.alarmUsers?.length > 0}
                            >
                                {i18n('SAVE')}
                            </Button>
                            <span className="label-save-bar">{i18n('or')}</span>
                            <span onClick={() => setParams({ type: 'list' })} className={'button-cancel-save'}>
                                {i18n('Cancel')}
                            </span>
                        </div>
                    </FormContainer>
                </div>
            </NewGroupScreenContainer>
            <NoUserModal show={showingModal} onHide={() => setShowingModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title">
                        <i className="far fa-exclamation-triangle"></i>
                        {i18n('Save group without users')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <label className={'label-modal'}>
                        {i18n('Are you sure you want save this group without any associated users?')}
                    </label>
                    <label>{i18n('You can add users editing this group later.')}</label>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="no-outline-button button-save"
                        bsStyle="primary"
                        onClick={handleSubmit(handleSave)}
                    >
                        {i18n('Confirm')}
                    </Button>
                    <Button
                        className="no-outline-button button-cancel"
                        type="button"
                        onClick={() => {
                            setShowingModal(false)
                        }}
                    >
                        {i18n('Cancel')}
                    </Button>
                </Modal.Footer>
            </NoUserModal>
        </>
    )
}
